var $ = require('jquery');
var Modernizr = require('Modernizr');

;(function() {
    "use strict";

    var options, /* options object */
        messages = {}, /* translations object */
        template, /* the HTML template that will be used */
        $mobile, /* the main mobile jQuery element */
        $overlay, /* the overlay jQuery element */
        $iframe, /* the iframe jQuery element in which the mobile preview is loaded */
        $oldLayouts, /* the promo for chosing a new layout jQuery element */
        $forceDesktop, /* the message shown when mobile view looks like desktop */
        $body, /* jQuery reference to the page body */
        toolbar; /* toolbar object */

    var setToolbar = function(_toolbar) {
        toolbar = _toolbar;
    };

    /**
     * initializes the user interface for the mobile preview frame
     */
    var initUi = function() {
        /* add the mobile preview button to the toolbar */
        if (toolbar &&  toolbar.Preview) {
            toolbar.Preview.showMobilePreviewStartButton();
        }

        /* add messages from jimdoData */
        $.extend(true, messages, jimdoData.messages.mobilepreview);

        template = '' +
            '<div class="mp-mobile-container">' +
            '   <div class="mp-mobile-frame">' +
            '       <div class="mp-close"></div>' +
            '       <div class="mp-iframe-wrapper"><iframe frameborder="0"></iframe></div>' +
            '       <div class="mp-force-desktop"><p>' + messages.forcedesktop.text + '</p></div>' +
            '       <div class="mp-old-layouts">' +
            '           <div class="mp-bubble">' +
            '               <p>' + messages.promolayouts.text + '</p>' +
            '               <button style="display: none;">' + messages.promolayouts.editor.button + '</button>' +
            '               <svg viewBox = "0 0 100 100" version = "1.1" width="34" height="34">' +
            '                   <path d="M 2 0 L 2 100 L 100 0" stroke="#0fabfc" stroke-width="2" fill="#ffffff"/>' +
            '               </svg>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</div>';

        // append the template
        $mobile = $(template).appendTo($body).wrap('<div class="diye"></div>');
        // append the overlay
        $overlay = $('<div id="mp-overlay"></div>')
            .appendTo($body)
            .wrap('<div class="diye"></div>');
        // get iframe reference
        $iframe = $mobile.find('.mp-mobile-frame iframe');
        // get old layouts message
        $oldLayouts = $mobile.find('.mp-old-layouts');
        // get force desktop message
        $forceDesktop = $mobile.find('.mp-force-desktop');

        /* iPad seems to need a few extra rules to display it correctly */
        if (Modernizr.touch) {
            $mobile.find('.mp-iframe-wrapper').addClass('mp-iframe-wrapper-ios');
        }

        // when clicking the "Select layout" button, Layout selector
        // should open with "Flexible Layouts" filter selected
        if (options.renderMode === 'editor') {
            $oldLayouts.find('button')
                .show()
                .button()
                .bind('click', function() {
                    close();
                    /*trigger click on SA Layouts entry*/
                    diy.editor.siteadmin.api.triggerMenuItem('cc-sa-item-layoutselector', {openTo: ''});
                    /*mark history change - to be able to switch back to the settings window*/
                    diy.editor.siteadmin.api.setSidebarActiveItem('cc-sa-item-layoutselector');
            });
        }

        // clicking the phone's home button should close it
        $mobile.find('.mp-close').bind('click', function() {
            close();
        });
    };

    /**
     * position the overlay so it covers all sitebuilder. take care of the
     * various toolbars such as testdrive, the undo redo toolbar and so on
     */
    var positionOverlay = function() {
        var top = $('#diyToolbar').offset().top + $('#diyToolbar').outerHeight();
        $overlay.css('top', top - $(window).scrollTop());
    };

    /**
     * close the mobile preview
     */
    var close = function() {
        if (options.renderMode == 'mobilepreview') {
            toolbar.Preview.backAction();
            return;
        }

        /* allow main document scrolling again */
        $(document).unbind('.mppreventscroll');

        /* set back scrolling to the main window when mobile preview is closed */
        $body.removeClass('mp-no-scroll');

        /* hide the mobile preview frame */
        $mobile.animate({
            bottom: -600
        }, 500, function() {
            $overlay.hide();
            /* set about:blank to free the iframe */
            $iframe.attr('src', 'about:blank');
        });

        /* update the undo redo toolbar state */
        toolbar.Preview.setMobilePreviewStateActive(false);
    };

    /**
     * open the mobile preview
     */
    var open = function() {

        if (options.renderMode == 'mobilepreview') {
            // we need to manually update the toolbar state, because this wasn't
            // necessarily open from the preview button
            toolbar.Preview.setMobilePreviewStateActive(true);
        }

        /* prevent ipad main document scrolling, as it interferes with the iframe scrolling */
        $(document).bind('touchmove.mppreventscroll touchdown.mppreventscroll', function(e) {
            e.preventDefault();
        });

        /* remove the scrolling on the main window when mobile preview is opened */
        $body.addClass('mp-no-scroll');
        $overlay.show();
        positionOverlay();

        /* show the mobile frame */
        $mobile.css({
            bottom: -600,
            marginBottom: '-282px'
        }).show().animate({
            bottom: '50%'
        }, 500);

        $oldLayouts.toggle(!options.responsive);
        $forceDesktop.toggle(!options.activateMobileOptimization);
        $iframe.toggle(options.responsive && options.activateMobileOptimization);

        /* if it has a responsive layout, open the web view */
        if (options.responsive && options.activateMobileOptimization) {
            /* set the mobile preview iframe source */
            var mobileSrc = "";
            if (options.renderMode === 'editor') {
                mobileSrc = $('.webView').attr('href');
            } else if (options.renderMode === 'web') {
                mobileSrc =  webserverProtocol + webServerName + location.pathname;
            } else if (options.renderMode === 'mobilepreview') {
                mobileSrc = options.previewPageUrl;
            }
            mobileSrc += '?mobilepreview=1&publicview=1';
            $iframe.attr('src', mobileSrc);
        }

        /* require two succesive clicks (not dblclick!) to close */
        $overlay.one('click', function() {
            $overlay.one('click', close);
        });
    };

    var initInnerBehaviour = function() {
        /* add mobilepreview class on the body
        reason is to enable some media queries that hide the apps
        only if in mobile preview, to simulate the live mobile device */
        $body.addClass('mobilepreview');

        /* append publicview and mobilepreview to all links */
        $('a[href]').bind('click', function() {
            var url = $(this).attr('href');
            /* only for local links (relative & absolute on the same domain) */
            if ('/' === url.charAt(0) || 0 === url.indexOf(webserverProtocol + webServerName)) {
                url += '?publicview=1&mobilepreview=1';
                $(this).attr('href', url);
            }
        });

        /* hide the "Logout" and "Edit page" in the footer */
        $('.loggedin').hide();

        /* block any actions in the modules and in the page */
        $('button, input[type="button"]').unbind('click');
        $('form').unbind('submit').bind('submit', function(){return false;});

        /* can't make the top link work properly due to the custom scrollbar */
        $('a.diyfeTopLink').hide();

        /* initialize the scrolling */
        var jspApi = $body.jScrollPane({
            mouseWheelSpeed: 40,
            horizontalGutter: 0,
            verticalGutter: 0
        }).data('jsp');

        /* the content height may change as some modules will load additional content */
        setInterval(function() {
            jspApi.reinitialise();
        }, 1000);
    };

    var init = function(_options) {
        options = $.extend(_options, {});

        $body = $('body');

        /*
        depending if this code gets executed in the mobile frame or outside of it
        it does two different things:
            - if it's executed inside the mobile preview frame:
                - add the mobile scrollbars
                - make sure that mobile preview links are being propagated further
                - disable all the modules in the page (so they can't be used)
            - if it's executed outside the mobile preview frame:
                - just create the mobile frame and run the web view in it
                - when running inside, it will do what is described at the first step
         */
        if (options['isMobilePreviewView']) {
            /* web view additions when invoked */
            initInnerBehaviour();
        } else {
            /* create the mobile preview elements */
            initUi();
        }
    };

    /* export public methods */
    return $.extend(this, {
        init: init,
        open: open,
        close: close,
        setToolbar: setToolbar
    });

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/mobilepreview/mobilepreview.js
 ** module id = 1211
 ** module chunks = 9 10
 **/